import axios from "axios";
import { Constants } from "../Constants";

export const getStates = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await axios.get(
      `${Constants.BASE_URL}locations/states`,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const getCities = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await axios.get(
      `${Constants.BASE_URL}locations/cities/${data.stateId}`,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};
